import { StaticHero } from './components';

function HomepageHero() {
  return <StaticHero />;
}

export default HomepageHero;
